import { render, staticRenderFns } from "./CreatePlayer.vue?vue&type=template&id=2d6a4c67&scoped=true&"
import script from "./CreatePlayer.vue?vue&type=script&lang=js&"
export * from "./CreatePlayer.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlayer.vue?vue&type=style&index=0&id=2d6a4c67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a4c67",
  null
  
)

export default component.exports